import React from "react";
import {Route} from "react-router-dom";
import InvoiceNumbering from "../../views/invoiceNumbering";
import RequireAuthentication from "../../hoc/authentication/requireAuthentication";
import {sessionStore} from "../../utils/sessionStore";
import {Authorizations, hasAuthorization} from "../../utils/authorizations";

let routes = [];
const applications = sessionStore.get("applications");
const authorizations = sessionStore.get("authorizations") ?? [];

if (
    applications
    && applications["marketplace"]
    && hasAuthorization(authorizations, Authorizations.GLOBAL_ORGANIZATION_MANAGEMENT)
) {
    routes.push([
        <Route
            path="/invoice_numbering"
            component={RequireAuthentication(InvoiceNumbering)}
            exact
            key="invoice_numbering"
        />,
    ])
}

export default routes;
